module.exports = __webpack_public_path__ + "img/inventory_tracking.b3b0b6c7.svg";